import { GridSelectionModel } from '@mui/x-data-grid-pro';
import * as React from 'react';

import { ActionHandler } from '../../../actions';
import { Actions } from './Actions';

interface Props {
  selection: GridSelectionModel;
  onAction: ActionHandler;
}

export const Selection: React.FC<Props> = (props) => {
  const count = props.selection.length;
  if (count <= 0) {
    return null;
  }

  return (
    <div className="flex space-x-6 items-center">
      <h4 className="text-blue-900 font-medium">
        {count} row{count > 1 ? 's' : ''} selected
      </h4>
      <Actions onAction={props.onAction} selection={props.selection} />
    </div>
  );
};
Selection.displayName = 'Selection';
